import * as yup from "yup";

import * as RHFBonusCardValidationRules from "@/utils/validation/schemas/bonusCard.RHF";

export const BonusCardRequestBalanceFormValidationSchema = yup.object({
    bonusCardNumber: RHFBonusCardValidationRules.bonusCardFormat
});

export type BonusCardRequestBalanceFormValues = yup.InferType<
    typeof BonusCardRequestBalanceFormValidationSchema
>;
